/*
 * Copyright (c) Nexign, JSC, 2019-2020.
 */
/**
 *
 *
 * @author Anton Panasenko
 * @author Aleksandr Perkhunov
 * @version 1.2.0
 * @since 1.0.0
 */

import moment from 'moment';

export const getTimeZone = (timestamp: number | string): string => {
    const utc = moment(timestamp).utcOffset() / 60;
    const timezone = utc < 10 ? `0${utc}` : utc
    return `(UTC+${timezone})`;
}
